import React from 'react';

function Header() {
  return (
    <header className="header">
      <div className="logo">
        <span>vairee</span>-talent
      </div>
    </header>
  );
}

export default Header;
